<div class="modal-header align-items-center text-primary pb-1">
	<div>
		<h3 class="font-weight-bold  mb-1" *ngIf="!board?.id">Add Travel Board</h3>
		<h3 class="font-weight-bold  mb-1" *ngIf="board?.id">Edit Travel Board</h3>
		<!-- <div class="text-small text-danger" *ngIf="board?.id">board: {{board.id}}</div>  -->
	</div>
    <button type="button" class="modal-close ml-auto" aria-label="Close" (click)="closeModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
</div>
<div class="modal-body text-primary pt-1">

	<div class="mb-3">

		<!-- <div class="bred P-3">ADD/EDIT TRAVEL BOARD FORM TO COME</div> -->
		<!-- <ng-container *ngIf="boards$ | async as boards; else noboards">
			<div *ngFor="let board of boards; let i = index; let last = last;"
				class="d-flex align-items-center tbli"
				[ngClass]="{'mb-1': i != last}"
				(click)="onSelectBoard(board)"
				>
				<span>{{board.name}}</span>
				<div class="btn btn-primary pill small ml-auto btn-save">Save</div>
			</div>
		</ng-container> -->

		<form 
			*ngIf="boardForm"
			[formGroup]="boardForm" 
			(ngSubmit)="onSubmit()" 
			>
			<input type="hidden" formControlName="id" />

			<div class="mb-3">

				<label class="form-label required">Name</label>
				<input type="text" 
					class="form-control" 
					formControlName="name" 
					[ngClass]="{'invalid': (boardForm.get('name').invalid && attemptedSubmit)}"
					maxlength="255" >
			</div>



			<label class="form-label">Cruise Information (optional)</label>
			<div class=" d-md-flex align-items-center mb-4">
				<!-- <div class="text-small" *ngIf="cruiseLines$ | async as cruiseLines;">{{cruiseLines | json}}</div> -->
				<select 
					[(ngModel)]="cruiseLineId"
					[ngModelOptions]="{standalone: true}"
					class="form-control mb-2 mb-md-0 mr-md-2  m-md-0 w-md-33"
					(change)="getCruiseLineShipNames()"
					>
					<option value="" >Your Cruise Line</option>
					<ng-template #noShipNames>
						<option value="" >loading cruise lines</option>
					</ng-template>
					<ng-container *ngIf="cruiseLines$ | async as cruiseLines; else noShipNames">
						<option [value]="cruiseLine.cruiseLineId" *ngFor="let cruiseLine of cruiseLines">{{cruiseLine.cruiseLineName}}</option>
					</ng-container>
				</select>
				<select 
					[(ngModel)]="cruiseLineShipName"
					[ngModelOptions]="{standalone: true}"
					class="form-control mb-2 mb-md-0 mr-md-2  m-md-0 w-md-33"
					[disabled]="cruiseLineId == ''"
					(change)="getCruiseLineShipSailDates()"
					>
					<option value="" >Ship Name</option>
					<ng-template #noShipNames>
						<option value="" >loading ship names</option>
					</ng-template>
					<ng-container *ngIf="cruiseLineShipNames$ | async as cruiseLineShipNames; else noShipNames">
						<option [value]="cruiseLineShipName" *ngFor="let cruiseLineShipName of cruiseLineShipNames">{{cruiseLineShipName}}</option>
					</ng-container>
				</select>

				<select 
					[(ngModel)]="codeToCruiseId"
					[ngModelOptions]="{standalone: true}"
					class="form-control mb-2 mb-md-0 mr-md-2  m-md-0 w-md-33"
					[disabled]="cruiseLineShipName == ''"
					>
					<option value="" >Departure Date</option>
					<ng-template #noSailDates>
						<option value="" >loading dates</option>
					</ng-template>
					<ng-container *ngIf="cruiseLineShipSailDates$ | async as cruiseLineShipSailDates; else noSailDates">
						<option [value]="cruiseLineShipSailDate.codeToCruiseId" *ngFor="let cruiseLineShipSailDate of cruiseLineShipSailDates">{{cruiseLineShipSailDate.sailDate | date: 'MMM d, y'}} - {{cruiseLineShipSailDate.nights}} nights</option>
					</ng-container>
				</select>

				<!-- <button type="button"
					class="btn btn-primary btn-circle-icon text-light"
					(click)="doSomething()"
					[disabled]="cruiseLineShipSailDate == ''">
					<fa-icon [icon]="['fas', 'search']"></fa-icon>
				</button> -->
			</div>


			<button type="submit" 
				class="btn btn-quinary btn-save pill font-weight-bold px-4"
				[disabled]="boardForm.get('name').invalid">Save Board</button>

			<app-response-message [responseMsg]="responseMsg" *ngIf="responseMsg"></app-response-message>
		</form>

		<ng-template #noboards>Travel Board not found.</ng-template>
	</div>


</div>
<!-- <div class="modal-footer">
    
	
</div> -->



<!-- <div class="text-small text-danger">productId: {{productId}}</div>  -->